import { render, staticRenderFns } from "./DateStat.vue?vue&type=template&id=28bfa4ba&scoped=true"
import script from "./DateStat.vue?vue&type=script&lang=js"
export * from "./DateStat.vue?vue&type=script&lang=js"
import style0 from "./DateStat.vue?vue&type=style&index=0&id=28bfa4ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bfa4ba",
  null
  
)

export default component.exports